import React, { Component } from "react";
import FormGroupCheckBox from "../shared/form/FormGroupCheckbox";
import { connect } from "react-redux";
import {
    setIsCommValueChanged
} from "../../actions/policy/policyActions";

const mapDispatchToProps = (dispatch) => {
    return {
        setIsCommValueChanged: (Value) => dispatch(setIsCommValueChanged(Value))
    };
};
export class OnboardingCommunicationPreferenceSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            CommPreference: [],
        };
        this.preferenceChanges = this.preferenceChanges.bind(this);
        this.updatedValue = this.updatedValue.bind(this);
    }

    updatedValue(communicationValue) {
        if (communicationValue !== null) {
            this.setState({
                CommPreference: communicationValue,
            });
        }
        else {
            this.setState({
                CommPreference: [],
            });
        }
    }
    
    preferenceChanges(event, CommunicationPreferenceId) {
        this.isCommunicationValueChanged(true);
        this.props.setIsCommValueChanged(true);
        const commPref = this.state.CommPreference;
        const index = commPref.findIndex(m => m.CommunicationPreferenceId === CommunicationPreferenceId);
        const masterData = this.props.commPrefsKeys.filter((val) => val.CommunicationPreferenceId === CommunicationPreferenceId);
        if (index !== -1) {
            let existflag = [];

            if (existflag.length !== 0 && commPref[index].PersonCommPrefId !== 0) {
                //Add or delete from existing preference
                commPref[index].IsDeleted = event.target.value === "false" ? true : false;
            }
            else {
                // delete entry from existing array(No->yes->No)
                commPref.splice(index, 1);
            }
            this.setState({
                CommPreference: commPref
            });
        }
        else {
            //New entry(No -> yes)
            let newValue;
            newValue = {
                PersonCommPrefId: 0,
                PersonId: "",
                CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
                CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
                CreatedBy: this.props.MemberName,
                LastUpdatedBy: this.props.MemberName,
                SourceSystem: "",
                SourcePersonId: "",
                IsDeleted: false
            };
            const newArrayVal = this.state.CommPreference;
            newArrayVal.push(newValue);
            this.setState({
                CommPreference: newArrayVal
            });
        }
        if (this.state.CommPreference.length === 0) {
            this.props.setIsCommValueChanged(false);
        }
        this.updateCommPreferences(this.state.CommPreference);
    }

    updateCommPreferences(CommPreference) {
        this.props.updateCommPreferences(CommPreference);
    }

    isCommunicationValueChanged(value) {
        this.props.isCommValueChanged(value);
    }

    render() {
        if (this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !== null) {
            return this.props.commPrefsKeys.length > 0 && this.props.commPrefsKeys.map((informMethod, index) => {
                let communicationOptionValue = false;
                return (
                    <FormGroupCheckBox
                        className={"form-group mt-0"}
                        type="checkbox"
                        id={"comm" + informMethod.CommunicationPreferenceName}
                        label={informMethod.CommunicationPreferenceName}
                        key={informMethod.CommunicationPreferenceName}
                        currentValue={communicationOptionValue}
                        onChange={(event) => {
                            this.preferenceChanges(event, informMethod.CommunicationPreferenceId);
                            return event.target.value === "true"
                                ? true
                                : event.target.value === "false"
                                    ? false
                                    : null;
                        }
                        }
                        Zebrafied={this.props.Zebrafied}
                        UseSlider={this.props.UseSlider}
                    />
                );
            });
        }
        return null;
    }
}

export default connect(
    null,
    mapDispatchToProps
)(OnboardingCommunicationPreferenceSection);